import { Month } from "@js-joda/core";
import React from "react";
import { CHEVRON_LEFT_ICON, CHEVRON_RIGHT_ICON } from "../../utils/svgs_new";
import { AppIcon } from "../Generic/AppIcon";

interface Props {
  year: number;
  month: Month;
  onClickPrevious: () => void;
  onClickNext: () => void;
  onChange: (year: number, month: number) => void;
}

const MonthPicker = (props: Props) => {
  const onChange = props.onChange;

  const input = React.useMemo(() => {
    const monthValue = props.month.value();
    const inputValue = props.year + "-" + (monthValue < 10 ? "0" : "") + monthValue.toString();

    return (
      <input
        type="month"
        value={inputValue}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          onChange(
            parseInt(e.target.value.split("-")[0], 10),
            parseInt(e.target.value.split("-")[1], 10)
          )
        }
        tabIndex={-1}
      />
    );
  }, [props.year, props.month, onChange]);

  return (
    <div className="MonthPicker">
      <AppIcon onClick={props.onClickPrevious} icon={CHEVRON_LEFT_ICON} size={10} />
      <div className="_input">{input}</div>
      <AppIcon onClick={props.onClickNext} icon={CHEVRON_RIGHT_ICON} size={10} />
    </div>
  );
};

export default MonthPicker;
